"use strict";

angular.module("licensure.services").factory("EXLocation", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/ExamModule/ExamLocations", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getfilter: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamLocationsFilter", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getlocation: function(id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamLocations/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (examLocation) {

                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/ExamModule/ExamLocations/";

                if (!isUndefined(examLocation.id)) {
                    method = "PUT";
                    url += examLocation.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: examLocation
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/ExamModule/ExamLocations/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

        };
    }
]);
